/* eslint-disable default-case */
import produce from 'immer';

import {
  types,
  Configuration,
  ConfigurationState,
  ConfigurationsActionTypes,
  CreateConfigurationPayload,
  GetConfigurationsPending,
  GetConfigurationsSuccess,
  GetConfigurationsError,
  CreateConfigurationPending,
  CreateConfigurationError,
  UpdateConfigurationPayload,
  UpdateConfigurationPending,
  UpdateConfigurationSuccess,
  UpdateConfigurationError,
  DeleteConfigurationPending,
  DeleteConfigurationError
} from './types';

// Actions
export const actions = {
  getConfigurations: (): ConfigurationsActionTypes => ({ type: types.GET_CONFIGURATIONS.REQUEST }),
  createConfiguration: (payload: CreateConfigurationPayload): ConfigurationsActionTypes => ({
    type: types.CREATE_CONFIGURATION.REQUEST,
    payload
  }),
  updateConfiguration: (payload: UpdateConfigurationPayload): ConfigurationsActionTypes => ({
    type: types.UPDATE_CONFIGURATION.REQUEST,
    payload
  }),
  deleteConfiguration: (payload: { id: string }): ConfigurationsActionTypes => ({
    type: types.DELETE_CONFIGURATION.REQUEST,
    payload
  }),
  resetAction: (): ConfigurationsActionTypes => ({ type: types.RESET_ACTION }),
  resetError: (): ConfigurationsActionTypes => ({ type: types.RESET_ERROR })
};

// Initial State
export const initialState: ConfigurationState = {
  configurations: [],
  action: {
    pending: false,
    success: false,
    error: null
  }
};

// Reducer
export const reducer = (
  state: ConfigurationState = initialState,
  action: ConfigurationsActionTypes
): ConfigurationState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case types.GET_CONFIGURATIONS.PENDING:
      case types.CREATE_CONFIGURATION.PENDING:
      case types.UPDATE_CONFIGURATION.PENDING:
      case types.DELETE_CONFIGURATION.PENDING:
        draft.action.pending = (
          action as
            | GetConfigurationsPending
            | CreateConfigurationPending
            | UpdateConfigurationPending
            | DeleteConfigurationPending
        ).payload;
        break;
      case types.GET_CONFIGURATIONS.SUCCESS:
        draft.configurations = (action as GetConfigurationsSuccess).payload;
        break;
      case types.CREATE_CONFIGURATION.SUCCESS:
      case types.DELETE_CONFIGURATION.SUCCESS:
        draft.action.success = true;
        break;
      case types.UPDATE_CONFIGURATION.SUCCESS:
        const payload = (action as UpdateConfigurationSuccess).payload;
        if (draft.configurations.length) {
          const configIndex = draft.configurations.findIndex((c) => c.id === (payload as Configuration).id);
          if (configIndex > -1) {
            Object.assign(draft.configurations[configIndex], payload);
          }
        }
        draft.action.success = true;
        break;
      case types.GET_CONFIGURATIONS.ERROR:
      case types.CREATE_CONFIGURATION.ERROR:
      case types.UPDATE_CONFIGURATION.ERROR:
      case types.DELETE_CONFIGURATION.ERROR:
        draft.action.error = (
          action as
            | GetConfigurationsError
            | CreateConfigurationError
            | UpdateConfigurationError
            | DeleteConfigurationError
        ).payload;
        break;
      case types.RESET_ACTION:
        draft.action = initialState.action;
        break;
      case types.RESET_ERROR:
        draft.action.error = initialState.action.error;
        break;
    }
  });
};
